import { render, staticRenderFns } from "./LocalInformation.vue?vue&type=template&id=15686362&scoped=true&"
import script from "./LocalInformation.vue?vue&type=script&lang=js&"
export * from "./LocalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15686362",
  null
  
)

export default component.exports